import React from "react";
import {Box, Button, Stack, TextBlock} from "@unibuddy/patron";
import styled from "styled-components";
import {Trans, useTranslation} from "@unibuddy/intl";

import PageHeader from "shared/Shared/components/PageHeader/PageHeader";
import ThemedLink from "shared/Navigation/components/ThemedLink/ThemedLink";
import {rootURL} from "shared/Utils/WhereAmI";

import {PageTitle} from "../../../../components/PageTitle/PageTitle";
import {WideContainer} from "../../../../components/WideContainer/WideContainer";

const Container = styled(WideContainer)`
    box-shadow: 0 3px 11px ${({theme}) => theme.colors.grey300};
`;

export const Minor = (props) => {
    const {t} = useTranslation("verifyAge");

    return (
        <Container>
            <PageTitle title={t("minor", "Minor")} />
            <Box padding={["small", "xxlarge"]}>
                <Stack space={"large"}>
                    <PageHeader
                        title={t("notQuietOld", "Whoops, you’re not quite old enough yet...")}
                    />
                    <TextBlock align={"center"}>
                        {t(
                            "termsOfUseRequireAdult",
                            "Our new terms of use require you to meet the online age restrictions of your particular region. " +
                                "You will be unable to proceed in the sign-up process today, however, " +
                                "we hope to see you in the near future when you meet the minimum age limit to sign-up. " +
                                "We apologise for the inconvenience.",
                        )}
                    </TextBlock>
                    <TextBlock align={"center"}>
                        <Trans t={t} i18nKey={"supportLink"}>
                            {"For any further assistance, please contact our "}
                            <ThemedLink external to="https://help.unibuddy.co/" target="_blank">
                                {"support team"}
                            </ThemedLink>
                        </Trans>
                    </TextBlock>
                    <Box>
                        <Button
                            color={"primary"}
                            block
                            onClick={() => {
                                return props.history.replace(
                                    `${rootURL(props.location.pathname)}/buddies`,
                                );
                            }}
                        >
                            {t("comebackLater", "I’ll come back another time!")}
                        </Button>
                    </Box>
                </Stack>
            </Box>
        </Container>
    );
};
